import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useMetaMask from '../../hooks/metamask';
import { logout } from '../../store/slices/authSlice';

const Header = () => {
    const { connect, disconnect, isActive, account } = useMetaMask();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);
    const dispatch = useDispatch();

    const logoutHandler = () => {
        dispatch(logout());
    };

    return (
        <header className="transparent">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="de-flex sm-pt10">
                            <div className="de-flex-col">
                                <div className="de-flex-col">
                                    <div id="logo">
                                        <Link to="/" className="logo-info">
                                            99 NFT Exchange
                                        </Link>
                                    </div>
                                </div>
                                {/* <div className="de-flex-col">
                                    <input id="quick_search" className="xs-hide" name="quick_search" placeholder="search item here..." type="text" />
                                </div> */}
                            </div>
                            <div className="de-flex-col header-col-mid">
                                <ul id="mainmenu">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/explore">Explore</Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/collection">Collections</Link>
                                    </li> */}
                                    <li>
                                        <Link to="/add-nft">Add NFT</Link>
                                    </li>
                                    <li>
                                        <Link to="/profile">Profile</Link>
                                    </li>
                                </ul>
                                {userLoggedIn && (
                                    <div className="menu_side_area header-btn-main">
                                        <button type="button" onClick={logoutHandler} className="btn-main">
                                            <span>Logout</span>
                                        </button>
                                        <span id="menu-btn"></span>
                                    </div>
                                )}
                                {isActive && !userLoggedIn && (
                                    <div className="menu_side_area header-btn-main">
                                        <Link to="/auth" className="btn-main">
                                            <i className="icon_wallet_alt"></i>
                                            <span>Sign In/Sign Up</span>
                                        </Link>
                                        <span id="menu-btn"></span>
                                    </div>
                                )}
                                {!isActive && (
                                    <div className="menu_side_area header-btn-main">
                                        <button type="button" onClick={() => connect()} className="btn-main">
                                            <i className="icon_wallet_alt"></i>
                                            <span>Connect</span>
                                        </button>
                                        <span id="menu-btn"></span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
